import { Page } from '@connected/ui/features/layouts';
import { createFileRoute } from '@tanstack/react-router';
// import { FilePlus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { HeaderNavigation } from '@/components/navigation/header-navigation';
// import { useGenerateInspectionPlan } from '@/hooks/use-generate-inspection-plan';

export const Route = createFileRoute('/(auth)/projects/$projectVersionId/inspection-plans')({
    component: Layout,
});

function Layout() {
    const { t } = useTranslation('inspection-plans');

    // const { handleGenerateInspectionPlan, disabled } = useGenerateInspectionPlan();

    return (
        <Page>
            <Page.Header className="pt-2.5">
                <Page.Header.Bar>
                    <Page.Header.Title>{t('layout.title')}</Page.Header.Title>
                    {/* <Page.Header.Actions>
                        <Page.Header.Action
                            variant="default"
                            icon={<FilePlus />}
                            disabled={disabled}
                            onClick={handleGenerateInspectionPlan}
                        />
                    </Page.Header.Actions> */}
                </Page.Header.Bar>
                <HeaderNavigation />
            </Page.Header>
            <Page.Outlet className="gap-4" />
        </Page>
    );
}
